import {
  getUrl,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
/* eslint-disable import/export */
export abstract class GetPresignedDownloadURLForSurveyRulesTemplateRPC implements
  LeoRPC<GetPresignedDownloadURLForSurveyRulesTemplateRPC.Request, GetPresignedDownloadURLForSurveyRulesTemplateRPC.Response, GetPresignedDownloadURLForSurveyRulesTemplateRPC.Errors.Errors>
{
  abstract execute(
    request: GetPresignedDownloadURLForSurveyRulesTemplateRPC.Request
  ): Promise<LeoRPCResult<GetPresignedDownloadURLForSurveyRulesTemplateRPC.Response, GetPresignedDownloadURLForSurveyRulesTemplateRPC.Errors.Errors>>;
}

export namespace GetPresignedDownloadURLForSurveyRulesTemplateRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {}

  export class Request implements LeoRPCRequest {
    readonly isGetPresignedDownloadURLForSurveyRulesTemplateRPCRequest: boolean = true;
    toDTO(): RequestDTO {
      return {}
    }
  }

  Request.prototype.toString = function toString(): string {
    return `GetPresignedDownloadURLForSurveyRulesTemplateRPC.Request`;
  };

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {
    documentURL: string;
  }
  
  export class Response implements LeoRPCResponse {
    readonly isGetPresignedDownloadURLForSurveyRulesTemplateResponse: boolean = true;
  
    readonly documentURL: URL;
  
  
    constructor(
    documentURL: URL
    ) {
      this.documentURL = documentURL;
    }
  
    static fromDTO(dto: ResponseDTO): Response {
      const documentURL = getUrl(dto, "documentURL", InvalidResponseDocumentUrlError);
      return new Response(
        documentURL
      );
    }
  
    toDTO(): ResponseDTO {
      const dto: ResponseDTO = {
          documentURL: this.documentURL.toString()
      };
      return dto;
    }
    }
  
  Response.prototype.toString = function toString(): string {
    return `GetPresignedDownloadURLForSurveyRulesTemplate(documentURL='${this.documentURL}')`;
  };
  


  export namespace Errors {

    export type Errors = any;
    export type ErrorsDTO = any;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}


export class InvalidResponseDocumentUrlError extends GetPresignedDownloadURLForSurveyRulesTemplateRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseDocumentUrlError";
  }
}

